import { render, staticRenderFns } from "./behaviour-card.vue?vue&type=template&id=4a177cdc"
import script from "./behaviour-card.vue?vue&type=script&lang=js"
export * from "./behaviour-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports